(function() {
'use strict';

angular
    .module('dashboard')
    .factory('dashboardService', dashboardService);

function dashboardService(
    $http,
    arrayUtil,
    imageService,
    fieldGroupService) {
    const domain = TRPCONFIG.Domain;
    let dashBoardAggPromise = null;
    const fieldTypes = fieldGroupService.getFieldTypes();
    const service = {
        getAggregate,
        clearAggregate,
        getHotelsById
    };

    function clearAggregate() {
        dashBoardAggPromise = null;
    }

    function _getDashBoardAggregates() {
        if (dashBoardAggPromise == null) {
            dashBoardAggPromise = $http.post('website/userdashboard/getestabbookings', {
                SortCriterion: 'Likes',
                CultureCode: domain.CultureCode,
                DomainId: domain.DomainId
            }, { ignoreErrors: true }).then(function(result) {
                const allEstabs = result.data.EstabBookingDetails;
                const userReviews = result.data.Reviews;

                const visitedEstabInfo = {
                    ReviewedHotels: [],
                    UnreviewedHotels: []
                };

                enrichData(allEstabs);

                angular.forEach(allEstabs, function(estab) {
                    estab.EstablishmentDetail.Url = estab.EstablishmentDetail.Url.replace('/', '');
                    if (estab.IsReviewedByUser) {
                        visitedEstabInfo.ReviewedHotels.push(estab);
                    } else {
                        visitedEstabInfo.UnreviewedHotels.push(estab);
                    }
                });

                const estabDict = arrayUtil.toDict(allEstabs, function(e) { return e.EstablishmentDetail.Id; }, function(e) {
                    e.EstablishmentDetail.ImageUrl = e.ImageUrl;
                    return e.EstablishmentDetail;
                });

                arrayUtil.map(userReviews, function(r) {
                    r.Establishment = estabDict[r.EstabId];
                    return r;
                });


                return {
                    estabs: visitedEstabInfo,
                    reviews: userReviews
                };
            });
        }

        return dashBoardAggPromise;
    }

    function enrichData(estabs) {
        angular.forEach(estabs, function(estab) {
            const dim = TRPCONFIG.DeviceSettings.LandingImageHeight;
            estab.ImageUrl = imageService.getMainImageUrl(estab.EstablishmentDetail.Id, dim, dim);
        });
    }

    function getHotelsById(estabIds) {
        return $http.post('/api/hotels/static/gethotelsbyid', {
            Ids: estabIds,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            FieldFlags: fieldGroupService.getFieldGroup([
                fieldTypes.Global,
                fieldTypes.Titles
            ])
        }, { ignoreErrors: true }).then(function(result) {
            return result.data;
        });
    }

    function getAggregate() {
        return _getDashBoardAggregates();
    }

    return service;
}
})();
